export default function PublicFootnotes({ q, branding }) {
  const validityDays = Math.max(1, parseInt(branding.validity_days, 10) || 15);
  const footerNote = (branding.footer_note || "").trim();
  return (
    <>
      {q.remarks && (
        <div className="card-luxe mb-4">
          <div className="overline text-white/50 mb-2">Remarks</div>
          <p className="text-sm text-white/80 whitespace-pre-wrap">{q.remarks}</p>
        </div>
      )}

      {/* Validity notice */}
      <div
        className="rounded-xl border border-[#C5A880]/30 bg-[#C5A880]/[0.06] px-4 py-3 mb-4 text-center"
        data-testid="public-validity-note"
      >
        <div className="overline text-[#C5A880] text-[10px] mb-1">Validity</div>
        <p className="text-sm text-white/80">
          This quotation is{" "}
          <span className="text-[#C5A880] font-semibold">
            valid for {validityDays} {validityDays === 1 ? "day" : "days"} only
          </span>{" "}
          from the date of issue.
        </p>
      </div>

      {/* Admin-configurable footer note */}
      {footerNote && (
        <div
          className="rounded-xl border border-white/10 bg-white/[0.02] px-4 py-3 mb-4"
          data-testid="public-footer-note"
        >
          <div className="overline text-white/40 text-[10px] mb-1">Note</div>
          <p className="text-sm text-white/70 whitespace-pre-wrap leading-snug">
            {footerNote}
          </p>
        </div>
      )}

      {q.customer.quotation_given_by && (
        <div className="text-center text-xs text-white/40 mt-8 mb-4">
          Prepared by <span className="text-white/70">{q.customer.quotation_given_by}</span>
        </div>
      )}
    </>
  );
}
